import styled from 'styled-components';

export const MapContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  margin-bottom: -8px;
  border-radius: 8px;
  overflow: hidden;
`;
